import { useState, useEffect } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    // Update the state with the current value
    setMatches(mediaQuery.matches);

    // Define the listener
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Add the listener
    mediaQuery.addEventListener('change', handleChange);

    // Clean up
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

// Preset media queries
export const useIsMobile = () => useMediaQuery('(max-width: 640px)');
export const useIsTablet = () =>
  useMediaQuery('(min-width: 641px) and (max-width: 1024px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1025px)');
export const useIsDarkMode = () =>
  useMediaQuery('(prefers-color-scheme: dark)');
export const useIsReducedMotion = () =>
  useMediaQuery('(prefers-reduced-motion: reduce)');
